// @ts-ignore
import * as dawaAutocomplete from 'dawa-autocomplete2';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import Input from './Input.js';
const AddressFinder = (props) => {
    const lang = useSelector((s) => s.lang);
    const inputRef = useRef(null);
    useEffect(() => {
        const autocomplete = dawaAutocomplete.dawaAutocomplete(inputRef.current, {
            select: (addr) => props.onSelect && props.onSelect(addr),
        });
        return () => autocomplete.destroy();
    }, []);
    return (React.createElement(AddressFinderWrapper, { className: props.className },
        React.createElement("div", { className: "autocomplete-container" },
            React.createElement(Input, { autofocus: props.autofocus, disabled: props.disabled, inputRef: inputRef, placeholder: props.placeholder || lang.inputs.searchAddress, button: props.button, onBlur: props.onBlur, onKeyDown: props.onKeyDown }))));
};
export default AddressFinder;
const AddressFinderWrapper = styled.div `
  .autocomplete-container {
    /* relative position for at de absolut positionerede forslag fÃ¥r korrekt placering.*/
    position: relative;
    width: 100%;
  }

  .autocomplete-container input {
    /* BÃ¥de input og forslag fÃ¥r samme bredde som omkringliggende DIV */
    width: 100%;
    box-sizing: border-box;
  }

  .dawa-autocomplete-suggestions {
    margin: 0px 0 0 0;
    padding: 0;
    text-align: left;
    border-radius: 0.3125em;
    background: #fcfcfc;
    box-shadow: 0 0.0625em 0.15625em rgba(0, 0, 0, 0.15);
    position: absolute;
    left: 0;
    right: 0;
    z-index: 9999;
    overflow-y: auto;
    box-sizing: border-box;
  }

  .dawa-autocomplete-suggestions .dawa-autocomplete-suggestion {
    margin: 0;
    list-style: none;
    cursor: pointer;
    padding: 0.4em 0.6em;
    color: #333;
    border: 0.0625em solid #ddd;
    border-bottom-width: 0;
  }

  .dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }

  .dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:last-child {
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
    border-bottom-width: 0.0625em;
  }

  .dawa-autocomplete-suggestions .dawa-autocomplete-suggestion.dawa-selected,
  .dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:hover {
    background: #f0f0f0;
  }
`;
//# sourceMappingURL=AddressFinder.js.map